<template>
  <div class="user-project-square">
    <div class="content">
        <div class="project-list-title">
            <span class="title">项目列表</span>
        </div>
        <a-divider style="margin:0px" />
        <div style="padding:24px 24px 50px 24px;">
          <a-table id="pro-table" :data-source="data" :pagination='false' :loading="ifShowLoading">
            <a-table-column key="name" title="" data-index="name">
              <template slot-scope="text, record">
                <div>
                  <span style="color:rgba(102, 102, 102, 1);font-size:16px;font-weight:bold">{{ record.name }}</span>
                </div>
                <div style="margin-top:20px">
                  <span style="color:rgba(170, 170, 170, 1);font-size:12px;">{{ record.description }}</span>
                </div>
              </template>
            </a-table-column>
            <a-table-column key="id" title="" data-index="id">
              <template slot-scope="text, record">
                <div style="text-align:center;">
                  <span @click="showTaskList(record.id)" style="color:rgba(255, 141, 26, 1);font-size:20px;font-weight:bold;cursor:pointer">{{ record.toStartTaskCount }}</span>
                </div>
                <div style="text-align:center">
                  <span style="color:rgba(170, 170, 170, 1);font-size:12px;">待领取</span>
                </div>
              </template>
            </a-table-column>
          </a-table>
          <div style="clear:botn;margin-bottom:34px;"></div>
          <div style="font-size:14px;margin-top:16px;float:left">
            <span style="color:rgba(80, 80, 80, 1)">总计：</span>
            <span style="color:rgba(24, 144, 255, 1)">{{total}}个</span>
          </div>
          <a-pagination
            style="float:right;margin-top:16px"
            v-model="currentPage"
            :page-size-options="pageSizeOptions"
            :total="total"
            show-size-changer
            :page-size="pageSize"
            @showSizeChange="onShowSizeChange"
            @change="onChangeSample"
          >
            <template slot="buildOptionText" slot-scope="props">
              <span>{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </div>
    </div>
    <a-modal v-model="visibleTaskModal" title="任务列表" :footer='null' :maskClosable='false' width='1230px'>
      <div style="max-height:650px;overflow-y:auto">
        <ul>
           <li style="background:#F0F0F0;color:rgba(80, 80, 80, 1);height:40px;line-height:40px;">
            <span style="display:inline-block;width:15%;float:left;padding-left:8px">任务编号</span>
            <span style="display:inline-block;width:12%;float:left;padding-left:8px">话句数量</span>
            <span style="display:inline-block;width:12%;float:left;padding-left:8px">正确单价</span>
            <span style="display:inline-block;width:12%;float:left;padding-left:8px">存疑单价</span>
            <span style="display:inline-block;width:12%;float:left;padding-left:8px">错误单价</span>
            <span style="display:inline-block;width:13%;float:left;padding-left:8px">已申报人数/总人数</span>
            <span style="display:inline-block;width:12%;float:left;padding-left:8px">截止日期</span>
            <span style="display:inline-block;width:12%;float:left;padding-left:8px">操作</span>
          </li>
          <li id="taskList" v-for="(item, index) in taskListData" :key="index" style="height:35px;line-height:35px;">
            <span style="display:inline-block;width:15%;float:left;padding-left:8px">{{item.seriesNo}}</span>
            <span style="display:inline-block;width:12%;float:left;padding-left:8px">{{item.wordCount}}</span>
            <span style="display:inline-block;width:12%;float:left;padding-left:8px">{{item.priceRight}}</span>
            <span style="display:inline-block;width:12%;float:left;padding-left:8px">{{item.priceDoubt}}</span>
            <span style="display:inline-block;width:12%;float:left;padding-left:8px">{{item.priceError}}</span>
            <span style="display:inline-block;width:13%;float:left;padding-left:8px">{{item.applyUserCount+""}}/{{item.userCount+''}}</span>
            <span style="display:inline-block;width:12%;float:left;color:rgba(170, 170, 170, 1);padding-left:8px">{{item.limitDate}}</span>
            <span v-if="!item.received" style="display:inline-block;width:12%;float:left;cursor:pointer;color:rgba(24, 144, 255, 1);padding-left:8px" @click="acceptTask(item.id)">领取任务</span>
            <span v-if="item.received" style="display:inline-block;width:12%;float:left;color:rgba(24, 144, 255, 1);padding-left:8px">已领取</span>
          </li>
        </ul>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'UserProjectSquare',
  props: {
    msg: String
  },
   data() {
    return {
      visibleTaskModal: false,
      data: [],
      ifShowLoading: false,
      currentPage: 1,
      pageSizeOptions: ['10', '20', '50', '100'],
      total: 0,
      pageSize: 10,
      taskLoading: false,
      dataCondition: {
        current: 1,
        size: 10
      },
      taskListData: [],
    }
  },
  methods: {
    showTaskList(id) {
      this.visibleTaskModal = true
      this.axios({
        url: '/api/user/project/task/list', 
        method: 'get',
        params: {
          projectId: id,
        }
      })
      .then(response=> {
        if(response.data.code == 0){
            this.taskListData = response.data.data
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    acceptTask(id) {
      this.visibleTaskModal = false
      this.$confirm({
          okText: '确定',
          cancelText: '取消',
          content: () => <div style="color:rgba(80, 80, 80, 1);">您确认要领取此任务吗？</div>,
          onOk: ()=> {
              this.acceptTaskOperate(id)
          },
          onCancel() {
              console.log('Cancel');
          },
          icon: 'warning',

      });
    },
    acceptTaskOperate(id) {
      this.axios.post('/api/user/project/task', {
        id: id,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.$parent.success('领取成功');
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    queryData() {
      this.axios({
        url: '/api/user/project/list', 
        method: 'get',
        params: {
            current: this.dataCondition.current,
            size: this.dataCondition.size,
        }
      })
      .then(response=> {
        if(response.data.code == 0){
            this.data = response.data.data.records
            this.total = response.data.data.total
        }else{
          this.$parent.error(response.data.message);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    onShowSizeChange(current, pageSize) {
      this.dataCondition.current = current
      this.dataCondition.size = pageSize;
      this.queryData()
    },
    onChangeSample(value) {
      this.dataCondition.current = value
      this.queryData()
    },
  },
  mounted: function() {
    this.queryData()
  }
}
</script>

<style lang="less">
  .user-project-square{
    padding: 24px;
    .content{
      border-radius: 4px;
      background: #fff;
      padding-bottom: 24px;
      .project-list-title{
          color: rgba(51, 51, 51, 1);
          font-size: 16px;
          height: 48px;
          line-height: 48px;
          padding-left: 24px;
      }
      .content-list{
          padding: 24px;
      }
      #pro-table{
        thead{
          display: none;
        }
      }
    }
  }
  .ant-checkbox-wrapper{
    margin-left: 0px;
  }
</style>
